import React from 'react';
import loadable from '@loadable/component';

const PageBuilder = loadable(() =>
  import(/* webpackChunkName: "PageBuilder" */ '../PageBuilder/PageBuilder')
);

const fallbackTerms = `


*Last Updated: October 4, 2026*

Welcome to our E-Moto Marketplace. By using our platform to browse, buy, or sell, you agree to these rules of the road. 

**1. Our Role in the Marketplace**
We provide a digital platform connecting local buyers and sellers of electric dirt bikes and parts. We do not own, inspect, or guarantee any of the items listed. Every transaction is strictly between the buyer and the seller. We are not responsible for the condition, safety, or legality of any bike or part sold. 

**2. Off-Road Use Only**
This is a critical rule of our community: **Bikes purchased or sold on this platform are specifically for off-road use only.** E-motos are not street-legal out of the box in most jurisdictions, and it is entirely your responsibility to understand and obey your local laws regarding where these vehicles can be ridden. 

**3. Assumption of Risk**
Riding electric dirt bikes is inherently dangerous. Modifying them or buying used, modified bikes carries additional risks. By using our platform, you acknowledge and accept all risks associated with purchasing, building, and riding used e-motos. Inspect everything carefully before you ride.

**4. User Conduct**
Keep it clean. You agree not to post fraudulent listings, sell stolen goods, or harass other users. If you are caught scamming or acting in bad faith, you will be permanently banned from the platform. 

**5. As-Is Sales**
Unless explicitly stated otherwise in writing by a seller, all items on this marketplace are sold "as-is," with no warranties expressed or implied. Buyers are responsible for performing their own due diligence before completing a purchase.
`;

export const fallbackSections = {
  sections: [
    {
      sectionType: 'article',
      sectionId: 'terms',
      appearance: { fieldType: 'customAppearance', backgroundColor: '#ffffff' },
      title: { fieldType: 'heading1', content: 'Terms of Service' },
      blocks: [
        {
          blockType: 'defaultBlock',
          blockId: 'hero-content',
          text: {
            fieldType: 'markdown',
            content: fallbackTerms,
          },
        },
      ],
    },
  ],
  meta: {
    pageTitle: {
      fieldType: 'metaTitle',
      content: 'Terms of service',
    },
    pageDescription: {
      fieldType: 'metaDescription',
      content: 'Terms of service for our emoto marketplace',
    },
  },
};

const FallbackPage = props => {
  return <PageBuilder pageAssetsData={fallbackSections} {...props} />;
};

export default FallbackPage;
